module.exports = __webpack_public_path__ + "img/medicine-ball.fcbe509e.jpg";